module.exports = __webpack_public_path__ + "img/queshengye.12901e12.jpg";